import React, { Component } from "react";

import * as ajax from "helpers/ajax";
import * as myFunctions from "helpers/functions";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"

import MDBox from "components/MDBox";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { InvertColorsOff } from "@mui/icons-material";



export default class Filters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    createInput=()=>{
        return this.props.data.fields.map((el)=>{
            if(el.topFilter){
            switch (el.type){
                case "select": return this.renderSelect(el);break;
            }
        }})
    }

    selectSelFilter=(key, val)=>{
        let temp = this.props.filters[key]?this.props.filters[key]:[];
        
        if (temp.includes(val)) {
            temp.splice(temp.indexOf(val), 1)
        } else {
          temp.push(val)
        }

        let statusFilter="";
        temp.map((el)=>{
            statusFilter+="&filters["+key+"][$in]="+el
        })

        this.props.setFilter(temp,key,statusFilter);
    }

    renderSelect=(el)=>{

        return (
            <div key={el.name+"-filter"}>
                {el.label}<br></br>
            <ToggleButtonGroup
            value={this.props.filters[el.name]}
            //onChange={(val) => this.props.setFilter(val.target.value,el.name,"&filters["+el.name+"][$eq]="+val.target.value)}
            onChange={(val) => this.selectSelFilter(el.name,val.target.value)}
            exclusive
            color={"secondary"}
            size={"small"}
        >
            {el.values.map((field)=>{
                return (
                <ToggleButton value={field} disabled={this.props.loading} key={field}>
                    {field.toUpperCase()}
                </ToggleButton>
                    )
            })}
        </ToggleButtonGroup>
        </div>
        )
    }

    filterVisible = () => {
        let bool = false;
        this.props.data.fields.map((el) => {
            if (el.topFilter) {
                bool = true;
            }
        })

        return bool
    }

    render() {
        if(!this.filterVisible()){return null}

        return (

            <MDBox bgColor="white"   
            borderRadius="lg"
            shadow="lg"
            opacity={1}
            p={2}
          >
                {this.createInput()}
            </MDBox>

        )
    }
}

Filters.defaultProps = {
    tableData: {},
}


